import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

export type HeaderVariant = 'white' | 'grey' | 'transparent'

interface Props {
  title?: string
  actionLeft?: ReactNode
  actionRight?: ReactNode
  children?: ReactNode
  isFixed?: boolean
  backgroundColor?: string
  variant?: HeaderVariant
}

export const Header: FC<Props> = ({
  actionLeft,
  actionRight,
  title = 'MTravel',
  children,
  isFixed = true,
  backgroundColor,
  variant = 'white',
}) => {
  return (
    <>
      <div
        style={{ backgroundColor: backgroundColor }}
        className={clsx(
          'container',
          'safe-area-top-padding',
          s.container,
          {
            [s.containerFixed]: isFixed,
          },
          s[variant],
        )}
      >
        <div className={clsx(s.left, s.action)}>{actionLeft}</div>

        {children ? children : <p className="bold-17">{title}</p>}

        <div className={clsx(s.right, s.action)}>{actionRight}</div>
      </div>

      {isFixed && <div className={clsx('safe-area-top-padding', s.back)} />}
    </>
  )
}
